import { Routes } from '@angular/router';
import { Home } from './modules/dashboard/home/home';
import { Login } from './modules/auth/login/login';
import { authGuard } from './core/guards/auth.guard';
import { loginGuard } from './core/guards/login.guard';



export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () => import('./modules/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('./modules/legal/legal.routes').then((m) => m.LEGAL_ROUTES),
  },
  {
    path: 'login',
    component: Login,
    canActivate: [loginGuard]
  },

   // Ruta para mostrar página de acceso no autorizado
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./shared/components/unauthorized/unauthorized').then(m => m.Unauthorized)
  },
  
  { path: '**', redirectTo: '' }
];
